
import { getDateStringVN } from "../../utils/DateTimeUtils";
import { tienFormat } from "../../utils/NumberUtils";
import _ from 'lodash'
import { DecimalAdd, GetLaiLoByPhanTramThau, GetTextTienHoi, TinhTienHoi } from "./reportTemplete";
/* Mẫu 4: miền tây
Thứ…, ngày… Khách
Tên khách
MN: 2C…da…dx… 3C…4C… (tiền qua cò)
Trúng: 2C… da…dx…3C…4C…(tiền trúng)
(Nếu là chuyển cho Chủ)
Thu = Lãi hay Bù = Lỗ * 0.95
(Nếu là nhận của khách)
Thu = Lãi * 0.95 hay Bù = Lỗ
*/
type groupItemKeyXacQuaCo = 'Lo2C3C' | '2CDD' | '4C' | 'dat' | 'dax' | 'XMB' | 'AB3C'
type groupItemKeyTrungThuong = '2CB' | '3CB' | '2CDD' | '3CB' | 'AB3C' | '4C' | 'dat' | 'dax' | 'XMB'
type GroupMapXacQuaCo = Record<groupItemKeyXacQuaCo, number>;
type GroupMapTrungThuong = Record<groupItemKeyTrungThuong, number>;
const templeteMienTay_details: { [key: string]: groupItemKeyXacQuaCo } = {
    "6Lo2c": "Lo2C3C",
    "DKC": "Lo2C3C",
    '6Lo3C': 'Lo2C3C',
    '7Lo2C': 'Lo2C3C',
    '8Lo2C': 'Lo2C3C',
    '7Lo3C': 'Lo2C3C',
    'DaT': 'dat',
    'Dau2C': '2CDD',
    'Dau4C': '4C',
    'DaX': 'dax',
    'Duoi2C': '2CDD',
    'Duoi4C': '4C',
    'Lo2C': 'Lo2C3C',
    'Lo3C': 'Lo2C3C',
    'Lo4C': '4C',
    'XC': 'AB3C',
    'XcDau': 'AB3C',
    'XcDuoi': 'AB3C',
    'Xi2': 'XMB',
    'Xi3': 'XMB',
    'Xi4': 'XMB',
}
const templeteMienTayMau5_total = {
    message: {} as any,
    MIEN: '',
    NGAY: '',
    //Qua cò
    QuaCo: {
        'Lo2C3C': 0,
        'AB3C': 0,
        '2CDD': 0,
        'dat': 0,
        'dax': 0,
        '4C': 0,
        'XMB': 0,
    } as GroupMapXacQuaCo,
    Xac: {
        'Lo2C3C': 0,
        'AB3C': 0,
        '2CDD': 0,
        'dat': 0,
        'dax': 0,
        '4C': 0,
        'XMB': 0,
    } as GroupMapXacQuaCo,
    //Tiền thưởng
    Trung: {
        '3CB': 0,
        '2CB': 0,
        'dat': 0,
        'dax': 0,
        '2CDD': 0,
        'AB3C': 0,
        '4C': 0,
        'XMB': 0
    } as GroupMapTrungThuong,
    TienTrung: {
        '3CB': 0,
        '2CB': 0,
        'dat': 0,
        'dax': 0,
        '2CDD': 0,
        'AB3C': 0,
        '4C': 0,
        'XMB': 0
    } as GroupMapTrungThuong,
    GetLaiLo: function () {
        let quaCo = 0;
        let tienThuong = 0;
        Object.keys(this.QuaCo).forEach(key => {
            quaCo += this.QuaCo[key as groupItemKeyXacQuaCo];
        })
        Object.keys(this.TienTrung).forEach(key => {
            tienThuong += this.TienTrung[key as groupItemKeyTrungThuong];
        })
        return quaCo - tienThuong;
    },
    GetSMS: function () {
        let sms = "";
        sms += this.MIEN + ":"
        if (this.QuaCo['Lo2C3C'] != 0) {
            sms += `Lô2C+lô3C:${tienFormat(this.Xac['Lo2C3C'], 1)}=`
            sms += `${tienFormat(this.QuaCo['Lo2C3C'], 1)}n\r\n`
        }
        if (this.QuaCo['2CDD'] != 0) {
            sms += `AB:${tienFormat(this.Xac['2CDD'], 1)}=`
            sms += `${tienFormat(this.QuaCo['2CDD'], 1)}n\r\n`
        }
        if (this.QuaCo['AB3C'] != 0) {
            sms += `AB 3C:${tienFormat(this.Xac['AB3C'], 1)}=`
            sms += `${tienFormat(this.QuaCo['AB3C'], 1)}n\r\n`
        }

        if (this.QuaCo['dat'] != 0) {
            sms += `Đá thẳng:${tienFormat(this.Xac['dat'], 1)}=`
            sms += `${tienFormat(this.QuaCo['dat'], 1)}n\r\n`
        }
        if (this.QuaCo['dax'] != 0) {
            sms += `Đá xiên:${tienFormat(this.Xac['dax'], 1)}=`
            sms += `${tienFormat(this.QuaCo['dax'], 1)}n\r\n`
        }


        if (this.QuaCo['4C'] != 0) {
            sms += `4C:${tienFormat(this.Xac['4C'], 1)}=`
            sms += `${tienFormat(this.QuaCo['4C'], 1)}n\r\n`
        }
        if (this.QuaCo['XMB'] != 0) {
            sms += `XMB:${tienFormat(this.Xac['XMB'], 1)}=`
            sms += `${tienFormat(this.QuaCo['XMB'], 1)}n\r\n`
        }
        //tien thuong
        let tmp = ""
        if (this.TienTrung['2CB'] != 0) {
            tmp += `Lô 2C:${this.Trung['2CB']}=${tienFormat(this.TienTrung['2CB'], 1)}n\r\n`
        }
        if (this.TienTrung['2CDD'] != 0) {
            tmp += `AB:${this.Trung['2CDD']}=${tienFormat(this.TienTrung['2CDD'], 1)}n\r\n`
        }
        if (this.TienTrung['3CB']! + 0) {
            tmp += `Lô 3C:${this.Trung['3CB']}=${tienFormat(this.TienTrung['3CB'], 1)}n\r\n`
        }
        if (this.TienTrung['AB3C']! + 0) {
            tmp += `AB 3C:${this.Trung['AB3C']}=${tienFormat(this.TienTrung['AB3C'], 1)}n\r\n`
        }
        if (this.TienTrung['dat'] != 0) {
            tmp += `Đá thằng:${this.Trung['dat']}=${tienFormat(this.TienTrung['dat'], 1)}n\r\n`
        }
        if (this.TienTrung['dax'] != 0) {
            tmp += `Đá xiên:${this.Trung['dax']}=${tienFormat(this.TienTrung['dax'], 1)}n\r\n`
        }

        if (this.TienTrung['4C'] != 0) {
            tmp += `4c:${this.Trung['4C']}=${tienFormat(this.TienTrung['4C'], 1)}n\r\n`
        }
        if (this.TienTrung['XMB'] != 0) {
            tmp += `XMB:${this.Trung['XMB']}=${tienFormat(this.TienTrung['XMB'], 1)}n\r\n`
        }
        if (tmp != "") {
            sms += "\r\nTrúng:" + tmp
        }
        const laiLo = this.GetLaiLo()
        const laiLoSauPt = laiLo / 100 * (100 - this.message.phanTramThau)
        const tienHoiSauPt = TinhTienHoi(this.message)
        if (laiLo > 0) {
            sms += "\r\nThu:" + GetLaiLoByPhanTramThau(laiLo, this.message.phanTramThau) + GetTextTienHoi(laiLoSauPt, tienHoiSauPt)
        } else if (laiLo < 0) {
            sms += "\r\nBù:" + GetLaiLoByPhanTramThau(laiLo, this.message.phanTramThau) + GetTextTienHoi(laiLoSauPt, tienHoiSauPt)
        } else {
            sms += "\r\nHoà"
        }
        sms += "\r\n-----\r\n"
        return sms;
    }
}
export function getSMSMau5MienTay(messages1: any) {
    const messages = Array.isArray(messages1) ? messages1 : (messages1 ? [messages1] : []);
    let smss: typeof templeteMienTayMau5_total[] = [];
    let ngay = ""
    let ten = ""
    let phanTramThau = 0
    messages && messages.length > 0 && messages.map((msg: any) => {
        let mien = "MN";
        if (msg.key == 1)
            mien = "MB";
        if (msg.key == 2)
            mien = "MT";

        let curSms: typeof templeteMienTayMau5_total = _.cloneDeep(templeteMienTayMau5_total);
        ngay = getDateStringVN(msg.date)
        curSms.MIEN = mien;
        curSms.message = msg
        ten = msg.contactName;
        phanTramThau = msg.phanTramThau;
        smss.push(curSms);
        msg.children && msg.children.map((group: any) => {
            group.children && group.children.map((item: any) => {
                const loaiCuocId: string = item.loaiCuocId;
                const groupId: string = templeteMienTay_details[loaiCuocId];
                switch (loaiCuocId) {
                    case "6Lo2c":
                        curSms.TienTrung["2CB"] = DecimalAdd(curSms.TienTrung["2CB"], item.thuong)
                        curSms.Trung["2CB"] = DecimalAdd(curSms.Trung["2CB"], item.trung)

                        curSms.QuaCo["Lo2C3C"] = DecimalAdd(curSms.QuaCo["Lo2C3C"], item.quaCo)
                        curSms.Xac["Lo2C3C"] = DecimalAdd(curSms.Xac["Lo2C3C"], item.xac)
                        break;
                    case "DKC":
                        curSms.TienTrung["2CB"] = DecimalAdd(curSms.TienTrung["2CB"], item.thuong)
                        curSms.Trung["2CB"] = DecimalAdd(curSms.Trung["2CB"], item.trung)
                        curSms.QuaCo["Lo2C3C"] = DecimalAdd(curSms.QuaCo["Lo2C3C"], item.quaCo)
                        curSms.Xac["Lo2C3C"] = DecimalAdd(curSms.Xac["Lo2C3C"], item.xac)
                        break;
                    case '6Lo3C':
                        curSms.TienTrung["3CB"] = DecimalAdd(curSms.TienTrung["3CB"], item.thuong)
                        curSms.Trung["3CB"] = DecimalAdd(curSms.Trung["3CB"], item.trung)

                        curSms.QuaCo["Lo2C3C"] = DecimalAdd(curSms.QuaCo["Lo2C3C"], item.quaCo)
                        curSms.Xac["Lo2C3C"] = DecimalAdd(curSms.Xac["Lo2C3C"], item.xac)
                        break;
                    case '7Lo2C':
                        curSms.TienTrung["2CB"] = DecimalAdd(curSms.TienTrung["2CB"], item.thuong)
                        curSms.Trung["2CB"] = DecimalAdd(curSms.Trung["2CB"], item.trung)

                        curSms.QuaCo["Lo2C3C"] = DecimalAdd(curSms.QuaCo["Lo2C3C"], item.quaCo)
                        curSms.Xac["Lo2C3C"] = DecimalAdd(curSms.Xac["Lo2C3C"], item.xac)
                        break;
                    case '8Lo2C':
                        curSms.TienTrung["2CB"] = DecimalAdd(curSms.TienTrung["2CB"], item.thuong)
                        curSms.Trung["2CB"] = DecimalAdd(curSms.Trung["2CB"], item.trung)

                        curSms.QuaCo["Lo2C3C"] = DecimalAdd(curSms.QuaCo["Lo2C3C"], item.quaCo)
                        curSms.Xac["Lo2C3C"] = DecimalAdd(curSms.Xac["Lo2C3C"], item.xac)
                        break;
                    case '7Lo3C':
                        curSms.TienTrung["3CB"] = DecimalAdd(curSms.TienTrung["3CB"], item.thuong)
                        curSms.Trung["3CB"] = DecimalAdd(curSms.Trung["3CB"], item.trung)

                        curSms.QuaCo["Lo2C3C"] = DecimalAdd(curSms.QuaCo["Lo2C3C"], item.quaCo)
                        curSms.Xac["Lo2C3C"] = DecimalAdd(curSms.Xac["Lo2C3C"], item.xac)
                        break;
                    case 'DaT':
                        curSms.TienTrung["dat"] = DecimalAdd(curSms.TienTrung["dat"], item.thuong)
                        curSms.Trung["dat"] = DecimalAdd(curSms.Trung["dat"], item.trung)

                        curSms.QuaCo["dat"] = DecimalAdd(curSms.QuaCo["dat"], item.quaCo)
                        curSms.Xac["dat"] = DecimalAdd(curSms.Xac["dat"], item.xac)
                        break;
                    case 'Dau2C':
                        curSms.TienTrung["2CDD"] = DecimalAdd(curSms.TienTrung["2CDD"], item.thuong)
                        curSms.Trung["2CDD"] = DecimalAdd(curSms.Trung["2CDD"], item.trung)

                        curSms.QuaCo["2CDD"] = DecimalAdd(curSms.QuaCo["2CDD"], item.quaCo)
                        curSms.Xac["2CDD"] = DecimalAdd(curSms.Xac["2CDD"], item.xac)
                        break;
                    case 'Dau4C':
                        curSms.TienTrung["4C"] = DecimalAdd(curSms.TienTrung["4C"], item.thuong)
                        curSms.Trung["4C"] = DecimalAdd(curSms.Trung["4C"], item.trung)

                        curSms.QuaCo["4C"] = DecimalAdd(curSms.QuaCo["4C"], item.quaCo)
                        curSms.Xac["4C"] = DecimalAdd(curSms.Xac["4C"], item.xac)
                        break;
                    case 'DaX':
                        curSms.TienTrung["dax"] = DecimalAdd(curSms.TienTrung["dax"], item.thuong)
                        curSms.Trung["dax"] = DecimalAdd(curSms.Trung["dax"], item.trung)

                        curSms.QuaCo["dax"] = DecimalAdd(curSms.QuaCo["dax"], item.quaCo)
                        curSms.Xac["dax"] = DecimalAdd(curSms.Xac["dax"], item.xac)
                        break;
                    case 'Duoi2C':
                        curSms.TienTrung["2CDD"] = DecimalAdd(curSms.TienTrung["2CDD"], item.thuong)
                        curSms.Trung["2CDD"] = DecimalAdd(curSms.Trung["2CDD"], item.trung)

                        curSms.QuaCo["2CDD"] = DecimalAdd(curSms.QuaCo["2CDD"], item.quaCo)
                        curSms.Xac["2CDD"] = DecimalAdd(curSms.Xac["2CDD"], item.xac)
                        break;
                    case 'Duoi4C':
                        curSms.TienTrung["4C"] = DecimalAdd(curSms.TienTrung["4C"], item.thuong)
                        curSms.Trung["4C"] = DecimalAdd(curSms.Trung["4C"], item.trung)

                        curSms.QuaCo["4C"] = DecimalAdd(curSms.QuaCo["4C"], item.quaCo)
                        curSms.Xac["4C"] = DecimalAdd(curSms.Xac["4C"], item.xac)
                        break;
                    case 'Lo2C':
                        curSms.TienTrung["2CB"] = DecimalAdd(curSms.TienTrung["2CB"], item.thuong)
                        curSms.Trung["2CB"] = DecimalAdd(curSms.Trung["2CB"], item.trung)

                        curSms.QuaCo["Lo2C3C"] = DecimalAdd(curSms.QuaCo["Lo2C3C"], item.quaCo)
                        curSms.Xac["Lo2C3C"] = DecimalAdd(curSms.Xac["Lo2C3C"], item.xac)
                        break;
                    case 'Lo3C':
                        curSms.TienTrung["3CB"] = DecimalAdd(curSms.TienTrung["3CB"], item.thuong)
                        curSms.Trung["3CB"] = DecimalAdd(curSms.Trung["3CB"], item.trung)

                        curSms.QuaCo["Lo2C3C"] = DecimalAdd(curSms.QuaCo["Lo2C3C"], item.quaCo)
                        curSms.Xac["Lo2C3C"] = DecimalAdd(curSms.Xac["Lo2C3C"], item.xac)
                        break;
                    case 'Lo4C':
                        curSms.TienTrung["4C"] = DecimalAdd(curSms.TienTrung["4C"], item.thuong)
                        curSms.Trung["4C"] = DecimalAdd(curSms.Trung["4C"], item.trung)

                        curSms.QuaCo["4C"] = DecimalAdd(curSms.QuaCo["4C"], item.quaCo)
                        curSms.Xac["4C"] = DecimalAdd(curSms.Xac["4C"], item.xac)
                        break;
                    case 'XC':
                        curSms.TienTrung["AB3C"] = DecimalAdd(curSms.TienTrung["AB3C"], item.thuong)
                        curSms.Trung["AB3C"] = DecimalAdd(curSms.Trung["AB3C"], item.trung)

                        curSms.QuaCo["AB3C"] = DecimalAdd(curSms.QuaCo["AB3C"], item.quaCo)
                        curSms.Xac["AB3C"] = DecimalAdd(curSms.Xac["AB3C"], item.xac)
                        break;
                    case 'XcDau':
                        curSms.TienTrung["AB3C"] = DecimalAdd(curSms.TienTrung["AB3C"], item.thuong)
                        curSms.Trung["AB3C"] = DecimalAdd(curSms.Trung["AB3C"], item.trung)

                        curSms.QuaCo["AB3C"] = DecimalAdd(curSms.QuaCo["AB3C"], item.quaCo)
                        curSms.Xac["AB3C"] = DecimalAdd(curSms.Xac["AB3C"], item.xac)
                        break;
                    case 'XcDuoi':
                        curSms.TienTrung["AB3C"] = DecimalAdd(curSms.TienTrung["AB3C"], item.thuong)
                        curSms.Trung["AB3C"] = DecimalAdd(curSms.Trung["AB3C"], item.trung)

                        curSms.QuaCo["AB3C"] = DecimalAdd(curSms.QuaCo["AB3C"], item.quaCo)
                        curSms.Xac["AB3C"] = DecimalAdd(curSms.Xac["AB3C"], item.xac)
                        break;
                    case 'Xi2':
                        curSms.TienTrung["XMB"] = DecimalAdd(curSms.TienTrung["XMB"], item.thuong)
                        curSms.Trung["XMB"] = DecimalAdd(curSms.Trung["XMB"], item.trung)

                        curSms.QuaCo["XMB"] = DecimalAdd(curSms.QuaCo["XMB"], item.quaCo)
                        curSms.Xac["XMB"] = DecimalAdd(curSms.Xac["XMB"], item.xac)
                        break;
                    case 'Xi3':
                        curSms.TienTrung["XMB"] = DecimalAdd(curSms.TienTrung["XMB"], item.thuong)
                        curSms.Trung["XMB"] = DecimalAdd(curSms.Trung["XMB"], item.trung)

                        curSms.QuaCo["XMB"] = DecimalAdd(curSms.QuaCo["XMB"], item.quaCo)
                        curSms.Xac["XMB"] = DecimalAdd(curSms.Xac["XMB"], item.xac)
                        break;
                    case 'Xi4':
                        curSms.TienTrung["XMB"] = DecimalAdd(curSms.TienTrung["XMB"], item.thuong)
                        curSms.Trung["XMB"] = DecimalAdd(curSms.Trung["XMB"], item.trung)

                        curSms.QuaCo["XMB"] = DecimalAdd(curSms.QuaCo["XMB"], item.quaCo)
                        curSms.Xac["XMB"] = DecimalAdd(curSms.Xac["XMB"], item.xac)
                        break;
                    default:
                        console.log('Bổ xung loại cược mới', loaiCuocId)
                }
            })
        })
    })
    let zSms = "Ngày:" + ngay + ". " + ten + "\r\n"
    let laiLo = 0;
    let tienHoiSauPt = 0;
    smss.forEach(sms => {
        zSms += sms.GetSMS()
        laiLo += sms.GetLaiLo()
        tienHoiSauPt += TinhTienHoi(sms.message)
    })
    const laiLoSauPt = laiLo / 100 * (100 - phanTramThau)
    if (messages.length > 1) {
        if (laiLo > 0) {
            zSms += "\r\nTổng cộng thu:" + GetLaiLoByPhanTramThau(laiLo, phanTramThau) + GetTextTienHoi(laiLoSauPt, tienHoiSauPt)
        } else if (laiLo < 0) {
            zSms += "\r\nTổng cộng bù:" + GetLaiLoByPhanTramThau(laiLo, phanTramThau) + GetTextTienHoi(laiLoSauPt, tienHoiSauPt)
        } else {
            zSms += "\r\nTổng cộng hoà"
        }
    }
    console.log(zSms)
    return zSms;
}